
import { ThemedLotsModel } from '../models/ThemedLotsModel.js';
import { ThemedLotsView } from '../views/ThemedLotsView.js';

export class ThemedLotsController {
    constructor() {

        this.model = new ThemedLotsModel();
        this.view = new ThemedLotsView();

        this.model.subscribe(state => this.view.render(state));
    }
}